import { steps, DATA_BG } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export const HowItWorks = () => (
  <section id="how" data-testid="how-section" className="relative py-28 border-t border-white/5 overflow-hidden">
    <div className="absolute inset-0">
      <img src={DATA_BG} alt="" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-ink/80" />
    </div>

    <div className="relative z-10 mx-auto max-w-7xl px-6">
      <Reveal className="max-w-2xl">
        <Overline>How It Works</Overline>
        <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
          From static rates to <span className="text-brand-green">live intelligence.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <div className="h-full rounded-xl border border-white/10 bg-ink/70 backdrop-blur-sm p-6 hover:border-brand-green/40 transition-colors">
              <span className="font-mono text-3xl font-bold text-brand-green/80">{s.n}</span>
              <h3 className="mt-4 font-heading font-bold text-xl">{s.t}</h3>
              <p className="mt-2 text-sm text-white/60">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
